/**
 * Created by jonas on 2020-11-04.
 */
import {gsap} from "gsap";
import {BS2} from "../BS2";

export class WinWayDisplay extends PIXI.Container {
    private _ways: PIXI.Text;

    constructor() {
        super();
        this.init();
    }

    public getShowAnimation(ways: number, duration: number): gsap.core.Timeline | undefined {
        if (ways <= 0) {
            this.alpha = 0;
            return undefined;
        }
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this.setWays(ways);
            this.alpha = 0;
        });

        tl.add(gsap.to(this, {duration: duration, alpha: 1, ease: "none"}));
        return tl;

    }

    public updateFontSize(countUpWidth: number): void {
        let fontSize: number = this._ways.style.fontSize
        while (this.width >= countUpWidth) {
            --fontSize;
            this._ways.style.fontSize = fontSize;
        }
    }

    public setWays(ways: number): void {
        this._ways.text = ways + " " + BS2.apiPlugin.translations.translate(ways > 1 ? "Ways" : "Way");
    }

    private init(): void {
        this._ways = new PIXI.Text("", {
            "fill": "#e82c2c",
            "fillGradientStops": [
                10
            ],
            "fontSize": 80,
            "fontWeight": "bolder",
            "letterSpacing": 1,
            "lineJoin": "round",
            "miterLimit": 0,
            "stroke": "#030303",
            "strokeThickness": 25
        });
        this._ways.anchor.set(0.5, 0.5);
        this.addChild(this._ways);
    }
}